import { Box } from '@mui/system';
import { CustomCellRendererProps } from 'ag-grid-react';
import { get } from 'lodash';
import { FC, useMemo } from 'react';
import { StoreCountTooltip } from '../StoreCountTooltip/StoreCountTooltip';

export const StoreCountCellRenderer: FC<CustomCellRendererProps> = ({ value, data, colDef }) => {
    const stores = useMemo(() => (colDef?.field ? get(data, colDef.field) : []), [data, colDef]);
    return (
        <StoreCountTooltip stores={Array.isArray(stores) ? stores : []}>
            <Box
                sx={{
                    textAlign: 'right',
                    width: '100%',
                }}
            >
                {value}
            </Box>
        </StoreCountTooltip>
    );
};
